






import Vue from 'vue'
import store from '@/store'
import bus from '@/services/bus'
import User from '@/models/Users/User'

export default Vue.extend({
  props: {
    id: String
  },
  data () {
    return {
      interval: null
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('mailing/get', to.params.id)
      // @ts-ignore
      bus.$emit('pathChanged')
      next()
    } catch (error) {
      console.error('LOG: beforeRouteEnter -> error', error)
      next('notFound')
    }
  },
  methods: {
    mailingDataWatcher (): void {
      // @ts-ignore
      let self = this;
      // @ts-ignore
      self.interval = setInterval(() => {
        if (this.user) {
          // @ts-ignore
          self.reloadMailing();
        }
      }, 2000)
    },
    reloadMailing (): void {
      this.$store.dispatch('mailing/get', this.id)
    },
    clearInterval (): void {
      // @ts-ignore
      clearInterval(this.interval)
    }
  },
  computed: {
    user (): User | false {
      return this.$store.state.user.user
    }
  },
  mounted () {
    this.mailingDataWatcher();
    this.$root.$on('relogin', this.clearInterval)
  },
  beforeDestroy () {
    this.clearInterval()
    this.$root.$off('relogin', this.clearInterval)
  }
})
